import { PeopleRole } from "../models/peopleCandidate";
import axiosConfig from "./axiosConfig";

// The live discovery + contact-enrichment op keys for a (lead, role), if any, so the
// Contacts panel can RE-ATTACH its progress poll on mount. A "Find people" / "Pull
// contact info" run keeps going server-side when the operator switches rows; without
// this the remounted panel loses its component-local op handle and paints "stopped".
// Presumed-dead ops are excluded server-side, so a crashed run never re-attaches as
// forever-running.
export interface LeadActivePeopleOps {
  role: PeopleRole;
  siteId: string;
  discoveryOperationKey: string | null;
  enrichmentOperationKey: string | null;
}

const getLeadActivePeopleOps = async (
  authToken: string,
  leadId: string,
  role: PeopleRole
): Promise<LeadActivePeopleOps> => {
  const { data } = await axiosConfig.get(`/leads/${leadId}/active-people`, {
    params: { role },
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data as LeadActivePeopleOps;
};

export default getLeadActivePeopleOps;
